// import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
// import { DragDropContext, Droppable, Draggable, DropResult, DroppableProvided, DraggableProvided } from '@hello-pangea/dnd';
// import imageCompression from "browser-image-compression";

// import api from '../../api/axiosConfig';

// // BƯỚC 1: CẬP NHẬT INTERFACE
// interface ProductData {
//   _id?: string;
//   slug: string;
//   isVisible: boolean;
//   order: number;
//   name_vi: string;
//   name_en: string;
//   description_vi: string;
//   description_en: string;
//   short_features_vi: string[];
//   short_features_en: string[];
//   relatedProducts: string[];
//   mainImage: string;
//   mainImageId?: string;          // ✅ public_id Cloudinary của ảnh chính
//   galleryImages: string[];
//   galleryImageIds?: string[];    // ✅ public_id của gallery
//   volumes: string[];
//   tabs: {
//     product_info: {
//       title_vi: string;
//       title_en: string;
//       content: {
//         benefits_vi: string[];
//         benefits_en: string[];
//         features_vi: string[];
//         features_en: string[];
//         image: string;
//         imageId?: string;
//       };
//     };
//     usage_guide: {
//       title_vi: string;
//       title_en: string;
//       content: {
//         method1_vi: { title: string; steps: string[] };
//         method1_en: { title: string; steps: string[] };
//         method2_vi: { title: string; steps: string[] };
//         method2_en: { title: string; steps: string[] };
//         video: string;
//       };
//     };
//     tech_specs: {
//       title_vi: string;
//       title_en: string;
//       content: {
//         specs_vi: string[];
//         specs_en: string[];
//         pdf: string;
//         pdfId?: string;
//       };
//     };
//   };
//   faq_vi: Array<{ question: string; answer: string }>;
//   faq_en: Array<{ question: string; answer: string }>;

//   oldMainImageId?: string;
//   oldPdfId?: string;
// }

// const getAuthToken = (): string | null => {
//   const userString = sessionStorage.getItem('user');
//   if (userString) {
//     try {
//       const userData = JSON.parse(userString);
//       return userData.accessToken || null;
//     } catch (error) {
//       console.error("Lỗi khi đọc user data từ sessionStorage:", error);
//       return null;
//     }
//   }
//   return null;
// };

// // Helper function to create absolute URL for assets
// const createAbsoluteUrl = (path: string | undefined | null) => {
//   if (!path) return '';
//   if (path.startsWith('http://') || path.startsWith('https://')) return path;
//   const base = (api.defaults.baseURL || '').replace(/\/api\/?$/, '');
//   return `${base}${path}`;
// };

// // BƯỚC 2: CẬP NHẬT BLANK PRODUCT
// const blankProduct: ProductData = {
//   slug: '',
//   isVisible: false,
//   order: 0,
//   name_vi: '',
//   name_en: '',
//   description_vi: '',
//   description_en: '',
//   short_features_vi: [],
//   short_features_en: [],
//   relatedProducts: [],
//   mainImage: '',
//   galleryImages: [],
//   volumes: [],
//   tabs: {
//     product_info: {
//       title_vi: 'Thông tin sản phẩm',
//       title_en: 'Product Information',
//       content: { benefits_vi: [], benefits_en: [], features_vi: [], features_en: [], image: '' },
//     },
//     usage_guide: {
//       title_vi: 'Hướng dẫn sử dụng',
//       title_en: 'Usage Guide',
//       content: {
//         method1_vi: { title: 'Cách sử dụng 1:', steps: [] },
//         method1_en: { title: 'Method 1:', steps: [] },
//         method2_vi: { title: 'Cách sử dụng 2:', steps: [] },
//         method2_en: { title: 'Method 2:', steps: [] },
//         video: '',
//       },
//     },
//     tech_specs: {
//       title_vi: 'Thông số kỹ thuật',
//       title_en: 'Technical Specs',
//       content: { specs_vi: [], specs_en: [], pdf: '' },
//     },
//   },
//   faq_vi: [],
//   faq_en: [],
// };

// const QLSanPham = () => {
//   // FIX: Moved apiUrl inside the component

//   const [products, setProducts] = useState<{ slug: string; name_vi: string; isVisible: boolean; order: number }[]>([]);
//   const [selectedProduct, setSelectedProduct] = useState<ProductData | null>(null);
//   const [isCreating, setIsCreating] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [isGalleryUploading, setIsGalleryUploading] = useState(false);
//   const [isPdfUploading, setIsPdfUploading] = useState(false);
//   const [isTogglingVisibility, setIsTogglingVisibility] = useState(false);

//   const fetchProducts = async () => {
//     setIsLoading(true);
//     try {
//       const token = getAuthToken();
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       const { data } = await api.get('/products?admin=true', config);
//       setProducts(
//         data.map((p: any) => ({
//           slug: p.slug,
//           name_vi: p.name_vi,
//           isVisible: p.isVisible,
//           order: p.order ?? 0,
//         }))
//         .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
//       );
//     } catch (error) {
//       console.error('Lỗi khi tải danh sách sản phẩm:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleReorder = async (result: DropResult) => {
//     if (!result.destination) return;

//     // Tạo bản sao mới và thay đổi vị trí
//     const newItems = Array.from(products);
//     const [moved] = newItems.splice(result.source.index, 1);
//     newItems.splice(result.destination.index, 0, moved);

//     // 🔹 Cập nhật lại order trong state
//     const reorderedWithOrder = newItems.map((p, index) => ({
//       ...p,
//       order: index, // cập nhật thứ tự mới
//     }));
//     setProducts(reorderedWithOrder);

//     console.log("New order:", reorderedWithOrder.map(p => `${p.slug}:${p.order}`));

//     try {
//       const token = getAuthToken();
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       await api.post("/products/reorder", reorderedWithOrder, config);
//       console.log("Cập nhật thứ tự thành công");
//     } catch (error) {
//       console.error("Lỗi khi cập nhật thứ tự:", error);
//       alert("Không thể lưu thứ tự mới!");
//     }
//   };




//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const handleNewProduct = () => {
//     setSelectedProduct(blankProduct);
//     setIsCreating(true);
//   };

//   const handleSelectProduct = async (slug: string) => {
//     setIsLoading(true);
//     setIsCreating(false);
//     setSelectedProduct(null);
//     try {
//       const token = getAuthToken();
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       const { data } = await api.get(`/products/${slug}`, config);
//       setSelectedProduct(data);
//     } catch (error) {
//       console.error(`Lỗi khi tải chi tiết sản phẩm ${slug}:`, error);
//       alert('Không thể tải chi tiết sản phẩm.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     if (!selectedProduct) return;
//     const { name, value } = e.target;

//     setSelectedProduct(prev => {
//       if (!prev) return null;
//       const newState = JSON.parse(JSON.stringify(prev));
//       const keys = name.split('.');
//       let currentLevel = newState;
//       for (let i = 0; i < keys.length - 1; i++) {
//         if (currentLevel[keys[i]] === undefined) {
//           currentLevel[keys[i]] = {};
//         }
//         currentLevel = currentLevel[keys[i]];
//       }
//       const finalKey = keys[keys.length - 1];
//       const arrayFields = ['galleryImages', 'short_features_vi', 'short_features_en', 'relatedProducts', 'volumes', 'benefits_vi', 'benefits_en', 'features_vi', 'features_en', 'specs_vi', 'specs_en', 'steps'];
//       if (arrayFields.includes(finalKey)) {
//         currentLevel[finalKey] = value.split('\n').filter(line => line.trim() !== '');
//       } else {
//         currentLevel[finalKey] = value;
//       }
//       return newState;
//     });
//   };
  
//   const handleToggleVisibility = async () => { 
//     if (!selectedProduct || isSaving || isTogglingVisibility) return; 
//     setIsTogglingVisibility(true); 
//     const newVisibility = !selectedProduct.isVisible; 
//     try { 
//       const token = getAuthToken(); 
//       if (!token) throw new Error("Vui lòng đăng nhập lại."); 
//       const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
//       // FIX: Added full API URL
//       await api.patch(`/products/${selectedProduct.slug}/visibility`, { isVisible: newVisibility }, apiConfig); 
//       setSelectedProduct({ ...selectedProduct, isVisible: newVisibility }); 
//       fetchProducts(); 
//     } catch (error: any) { 
//       console.error("Lỗi khi cập nhật trạng thái hiển thị:", error); 
//       alert(error.response?.data?.message || "Cập nhật trạng thái thất bại!"); 
//     } finally { 
//       setIsTogglingVisibility(false); 
//     } 
//   };
  

//   const handleGenericImageUpload = async (e: ChangeEvent<HTMLInputElement>, fieldName: string) => {
//     let file = e.target.files?.[0];
//     if (!file) return;

//     // ⚡ Giảm dung lượng ảnh xuống < 1MB để tránh proxy Render chặn
//     try {
//       const options = {
//         maxSizeMB: 1, // ảnh sau nén < 1MB (Render chắc chắn chấp nhận)
//         maxWidthOrHeight: 1600, // resize xuống max 1600px (đủ đẹp cho web)
//         useWebWorker: true,
//         fileType: "image/webp", // ép JPG → giảm mạnh size
//       };

//       console.log("📌 Dung lượng ảnh ban đầu:", (file.size / 1024 / 1024).toFixed(2), "MB");

//       const compressedFile = await imageCompression(file, options);

//       console.log(
//         "📉 Dung lượng ảnh sau nén:",
//         (compressedFile.size / 1024 / 1024).toFixed(2),
//         "MB"
//       );

//       file = compressedFile;
//     } catch (err) {
//       console.warn("⚠ Lỗi nén ảnh, dùng ảnh gốc:", err);
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     setIsUploading(true);

//     try {
//       const token = getAuthToken();
//       const config = {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       };

//       // Upload đến backend
//       const { data } = await api.post(
//         "/upload/image?scope=products",
//         formData,
//         config
//       );

//       const { url, public_id } = data;

//       // Ảnh đại diện
//       if (fieldName === "mainImage") {
//         setSelectedProduct((prev) =>
//           prev
//             ? { ...prev, mainImage: url, mainImageId: public_id }
//             : null
//         );
//       } else {
//         // Ảnh trong tab
//         const syntheticEvent = {
//           target: { name: fieldName, value: url, type: "text" },
//         } as unknown as React.ChangeEvent<HTMLInputElement>;
//         handleInputChange(syntheticEvent);
//       }
//     } catch (error) {
//       console.error(`❌ Lỗi khi tải ảnh cho ${fieldName}:`, error);
//       alert("Tải ảnh lên thất bại.");
//     } finally {
//       setIsUploading(false);
//     }
//   };
  
//   const handleGalleryUpload = async (e: ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files || files.length === 0) return;

//     const token = getAuthToken();
//     if (!token) return alert("Bạn chưa đăng nhập");

//     setIsGalleryUploading(true);

//     const config = {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const newUrls: string[] = [];
//     const newIds: string[] = [];

//     // 🔥 Upload từng file 1 request
//     for (let i = 0; i < files.length; i++) {
//       let file = files[i];

//       // 1) ⚡ GIẢM DUNG LƯỢNG ẢNH xuống < 1MB
//       try {
//         const options = {
//           maxSizeMB: 1, // ảnh < 1MB => chắc chắn lọt Render
//           maxWidthOrHeight: 1600,
//           useWebWorker: true,
//           fileType: "image/webp",
//         };
//         file = await imageCompression(file, options);
//       } catch (err) {
//         console.warn("Không nén được ảnh, dùng ảnh gốc:", err);
//       }

//       // 2) 🔥 Upload ảnh từng cái
//       const formData = new FormData();
//       formData.append("files", file);

//       try {
//         const { data } = await api.post(
//           "/upload/images?scope=products",
//           formData,
//           config
//         );

//         // BE trả về items (1 item)
//         const item = data.items[0];
//         newUrls.push(item.url);
//         newIds.push(item.public_id);

//       } catch (error) {
//         console.error("❌ Lỗi khi upload 1 ảnh gallery:", error);
//         alert("Không thể upload một ảnh trong gallery.");
//       }
//     }

//     // 3) ⚡ Cập nhật state sau khi upload xong toàn bộ
//     setSelectedProduct((prev) =>
//       prev
//         ? {
//             ...prev,
//             galleryImages: [...prev.galleryImages, ...newUrls],
//             galleryImageIds: [...(prev.galleryImageIds || []), ...newIds],
//           }
//         : null
//     );

//     setIsGalleryUploading(false);
//   };
  
//   const handleRemoveGalleryImage = (imageUrl: string) => { 
//     if (selectedProduct) { 
//       setSelectedProduct({ ...selectedProduct, galleryImages: selectedProduct.galleryImages.filter(url => url !== imageUrl) }); 
//     } 
//   };
  
//   const handlePdfUpload = async (e: ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (file.type !== "application/pdf") {
//       alert("Vui lòng chọn đúng file PDF!");
//       return;
//     }

//     // ⚠ Kiểm tra dung lượng PDF trước khi upload
//     const sizeMB = file.size / 1024 / 1024;
//     if (sizeMB > 5) {
//       return alert(
//         `File PDF quá lớn (${sizeMB.toFixed(
//           2
//         )} MB). Giới hạn an toàn là ≤ 5MB do Render.`
//       );
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     setIsPdfUploading(true);
//     try {
//       const token = getAuthToken();
//       const config = {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       };

//       const { data } = await api.post("/upload/pdf?scope=docs", formData, config);

//       const { url, public_id } = data;

//       setSelectedProduct((prev) =>
//         prev
//           ? {
//               ...prev,
//               tabs: {
//                 ...prev.tabs,
//                 tech_specs: {
//                   ...prev.tabs.tech_specs,
//                   content: {
//                     ...prev.tabs.tech_specs.content,
//                     pdf: url,
//                     pdfId: public_id,
//                   },
//                 },
//               },
//             }
//           : null
//       );

//       alert("Tải file PDF thành công!");
//     } catch (error: any) {
//       console.error("❌ Lỗi khi tải PDF:", error);
//       alert(error.response?.data?.message || "Tải file PDF thất bại.");
//     } finally {
//       setIsPdfUploading(false);
//     }
//   };



//   const handleSave = async () => { 
//     if (!selectedProduct) return; 
//     if (isCreating) { 
//       const requiredFields = { slug: 'Slug', name_vi: 'Tên sản phẩm (VI)', name_en: 'Product Name (EN)', description_vi: 'Mô tả ngắn (VI)', description_en: 'Short Description (EN)', mainImage: 'Ảnh đại diện' }; 
//       for (const [key, name] of Object.entries(requiredFields)) { 
//         if (!selectedProduct[key as keyof ProductData]) { 
//           alert(`Vui lòng không để trống trường: "${name}"`); 
//           return; 
//         } 
//       } 
//     } 
//     setIsSaving(true); 
//     try { 
//       const token = getAuthToken(); 
//       if (!token) throw new Error("Vui lòng đăng nhập lại."); 
//       const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
      
//       if (isCreating) { 
//         // FIX: Added full API URL
//         await api.post('/products', selectedProduct, apiConfig); 
//         alert(`Tạo thành công sản phẩm!`); 
//       } else { 
//         // FIX: Added full API URL
//         let payload = { ...selectedProduct };

//         // ✅ Nếu sản phẩm đã có mainImageId cũ, thêm oldMainImageId để BE tự xoá
//         if (!isCreating && selectedProduct.oldMainImageId) {
//           payload.oldMainImageId = selectedProduct.oldMainImageId;
//         }


//         // ✅ Nếu có PDF cũ, thêm oldPdfId
//         const pdfId = selectedProduct.tabs?.tech_specs?.content?.pdfId;
//         if (pdfId) {
//           payload.oldPdfId = pdfId;
//         }

//         await api.put(`/products/${selectedProduct.slug}`, payload, apiConfig);
//         alert(`Lưu thành công sản phẩm!`); 
//       } 
      
//       setSelectedProduct(null); 
//       fetchProducts(); 
//     } catch (error: any) { 
//       console.error("Lỗi khi lưu sản phẩm:", error); 
//       alert(error.response?.data?.message || "Thao tác thất bại!"); 
//     } finally { 
//       setIsSaving(false); 
//     } 
//   };

//   const handleDelete = async () => { 
//     if (!selectedProduct) return; 
//     const isConfirmed = window.confirm(`Bạn có chắc chắn muốn xóa sản phẩm "${selectedProduct.name_vi}" không?`); 
//     if (isConfirmed) { 
//       try { 
//         const token = getAuthToken(); 
//         if (!token) throw new Error("Vui lòng đăng nhập lại."); 
//         const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
        
//         // FIX: Added full API URL
//         await api.delete(`/products/${selectedProduct.slug}`, apiConfig); 
        
//         alert('Xóa sản phẩm thành công!'); 
//         setSelectedProduct(null); 
//         fetchProducts(); 
//       } catch (error: any) { 
//         console.error("Lỗi khi xóa sản phẩm:", error); 
//         alert(error.response?.data?.message || "Thao tác xóa thất bại!"); 
//       } 
//     } 
//   };
  
//   const handleFaqChange = (index: number, lang: 'vi' | 'en', field: 'question' | 'answer', value: string) => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const updatedFaqs = [...selectedProduct[faqKey]]; updatedFaqs[index] = { ...updatedFaqs[index], [field]: value }; setSelectedProduct({ ...selectedProduct, [faqKey]: updatedFaqs }); };
//   const addFaqItem = (lang: 'vi' | 'en') => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const newFaq = { question: '', answer: '' }; setSelectedProduct({ ...selectedProduct, [faqKey]: [...selectedProduct[faqKey], newFaq] }); };
//   const removeFaqItem = (index: number, lang: 'vi' | 'en') => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const updatedFaqs = selectedProduct[faqKey].filter((_, i: number) => i !== index); setSelectedProduct({ ...selectedProduct, [faqKey]: updatedFaqs }); };
//   const handleFormSubmit = (e: FormEvent) => { e.preventDefault(); handleSave(); };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4 sm:p-6 lg:p-8">
//       <h1 className="text-3xl font-bold text-gray-800 mb-6">Quản Lý Sản Phẩm</h1>
//       <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
//         <div className="md:col-span-4 lg:col-span-3 bg-white p-4 rounded-lg shadow-md self-start overflow-visible">
//           <h2 className="text-xl font-semibold mb-2 border-b pb-2">Danh sách sản phẩm</h2>
//           <button onClick={handleNewProduct} className="w-full bg-green-600 text-white font-bold py-2 px-4 rounded-md hover:bg-green-700 transition-colors mb-4">+ Tạo sản phẩm mới</button>
//           {isLoading ? (
//             <p>Đang tải...</p>
//           ) : (
//             <DragDropContext
//   onDragEnd={(result) => {
//     console.log('Drag event:', result); // kiểm tra có hoạt động không
//     handleReorder(result);
//   }}
// >
//   <Droppable droppableId="productList">
//     {(provided: DroppableProvided) => (
//       <ul
//         ref={provided.innerRef}
//         {...provided.droppableProps}
//         className="space-y-2 select-none"
//       >
//         {products.map((product, index) => (
//           <Draggable key={product.slug} draggableId={product.slug} index={index}>
//             {(provided: DraggableProvided) => (
//               <li
//                 ref={provided.innerRef}
//                 {...provided.draggableProps}
//                 {...provided.dragHandleProps}
//                 className={`border rounded-md bg-gray-50 hover:bg-blue-100 cursor-grab active:cursor-grabbing transition-all shadow-sm ${
//                   selectedProduct?.slug === product.slug ? 'ring-2 ring-blue-400' : ''
//                 }`}
//               >
//                 <button
//                   onClick={() => handleSelectProduct(product.slug)}
//                   className="w-full text-left p-3 flex justify-between items-center"
//                 >
//                   <span className="font-medium">{product.order + 1}. {product.name_vi}</span>
//                   <span
//                     className={`text-xs font-bold px-2 py-1 rounded-full ${
//                       product.isVisible
//                         ? 'bg-green-100 text-green-800'
//                         : 'bg-red-100 text-red-800'
//                     }`}
//                   >
//                     {product.isVisible ? 'Bật' : 'Tắt'}
//                   </span>
//                 </button>
//               </li>
//             )}
//           </Draggable>
//         ))}
//         {provided.placeholder}
//       </ul>
//     )}
//   </Droppable>
// </DragDropContext>

//           )}

//         </div>
//         <div className="md:col-span-8 lg:col-span-9 bg-white p-6 rounded-lg shadow-md">
//           {isLoading && !selectedProduct ? ( <div className="flex justify-center items-center h-full"><p>Đang tải...</p></div> ) : selectedProduct ? (
//             <form onSubmit={handleFormSubmit}>
//               <h2 className="text-2xl font-bold mb-6 text-gray-800">{isCreating ? "Tạo Sản Phẩm Mới" : `Chỉnh Sửa: ${selectedProduct.name_vi}`}</h2>
//               <div className="space-y-6">
//                 <div className="p-4 border rounded-md bg-gray-50">
//                   <h3 className="font-bold text-lg mb-3">Thông Tin Chung</h3>
//                   <div className="mb-4 p-3 rounded-md flex items-center justify-between bg-yellow-100 border border-yellow-300">
//                     <span className="font-bold text-yellow-800">Trạng thái: {selectedProduct.isVisible ? '🟢 Đang hiển thị' : '🔴 Đang ẩn'}</span>
//                     <button type="button" onClick={handleToggleVisibility} disabled={isTogglingVisibility} className={`px-4 py-2 text-white font-semibold rounded-md transition-colors ${ selectedProduct.isVisible ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600' } disabled:bg-gray-400`}>{isTogglingVisibility ? 'Đang xử lý...' : (selectedProduct.isVisible ? 'Tắt Hiển Thị' : 'Bật Hiển Thị')}</button>
//                   </div>
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Slug (URL)</label>
//                   <input type="text" name="slug" value={selectedProduct.slug} onChange={handleInputChange} className={`w-full p-2 border rounded mb-4 ${!isCreating ? 'bg-gray-200 cursor-not-allowed' : ''}`} readOnly={!isCreating} />
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Ảnh đại diện</label>
//                   <input type="file" onChange={(e) => handleGenericImageUpload(e, 'mainImage')} className="w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 mb-2"/>
//                   {isUploading && <p className="text-sm text-blue-600 mt-1">Đang tải lên...</p>}
//                   {selectedProduct.mainImage && <div className="mt-2 border p-2 rounded-md w-32 h-32"><img src={createAbsoluteUrl(selectedProduct.mainImage)} alt="Xem trước" className="w-full h-full object-contain"/></div>}
//                   <label className="block text-sm font-bold text-gray-700 mt-4 mb-1">Thư viện ảnh</label>
//                   <input type="file" multiple onChange={handleGalleryUpload} className="w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100 mb-2"/>
//                   {isGalleryUploading && <p className="text-sm text-green-600 mt-1">Đang tải lên thư viện ảnh...</p>}
//                   <div className="mt-2 flex flex-wrap gap-4">{selectedProduct.galleryImages.map((url, index) => (<div key={index} className="relative w-32 h-32 border p-1 rounded-md"><img src={createAbsoluteUrl(url)} alt={`Gallery image ${index + 1}`} className="w-full h-full object-contain" /><button type="button" onClick={() => handleRemoveGalleryImage(url)} className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center -mt-2 -mr-2 hover:bg-red-700" aria-label="Xóa ảnh">&times;</button></div>))}</div>
//                   <label className="block text-sm font-bold text-gray-700 mt-4 mb-1">Sản phẩm liên quan (mỗi slug một dòng)</label>
//                   <textarea name="relatedProducts" value={selectedProduct.relatedProducts.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded" placeholder="Nhập slug của các sản phẩm liên quan..."/>
//                 </div>
//                 <div className="p-4 border rounded-md bg-gray-50">
//                   <h3 className="font-bold text-lg mb-3 text-blue-700">Nội Dung Tiếng Việt (VI)</h3>
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Tên sản phẩm</label>
//                   <input type="text" name="name_vi" value={selectedProduct.name_vi} onChange={handleInputChange} className="w-full p-2 border rounded mb-2" />
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Mô tả ngắn</label>
//                   <textarea name="description_vi" value={selectedProduct.description_vi} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded mb-2" />
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Đặc điểm nổi bật ngắn (mỗi mục một dòng)</label>
//                   <textarea name="short_features_vi" value={selectedProduct.short_features_vi.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded mb-2" placeholder="VD: Ship toàn quốc"/>
//                   <label className="block text-sm font-bold text-gray-700 mt-4 mb-1">Dung tích sản phẩm (mỗi dung tích một dòng)</label>
//                   <textarea name="volumes" value={selectedProduct.volumes.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded" placeholder="Ví dụ:&#10;100ml&#10;250ml&#10;500ml"/>
//                 </div>
//                 <div className="p-4 border rounded-md bg-gray-50">
//                   <h3 className="font-bold text-lg mb-3 text-green-700">Nội Dung Tiếng Anh (EN)</h3>
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Product Name</label>
//                   <input type="text" name="name_en" value={selectedProduct.name_en} onChange={handleInputChange} className="w-full p-2 border rounded mb-2" />
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Short Description</label>
//                   <textarea name="description_en" value={selectedProduct.description_en} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded mb-2" />
//                   <label className="block text-sm font-bold text-gray-700 mb-1">Short Key Features (one per line)</label>
//                   <textarea name="short_features_en" value={selectedProduct.short_features_en.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded mb-2" placeholder="E.g.: Nationwide shipping"/>
//                 </div>

//                 <div className="p-4 border rounded-md bg-gray-50">
//                   <h3 className="font-bold text-2xl mb-4 text-center">Chi Tiết Sản Phẩm (Các Tab)</h3>
//                   <details className="mb-4 border rounded p-3 bg-white" open><summary className="font-bold text-lg cursor-pointer text-gray-700">1. Tab: Thông tin sản phẩm</summary><div className="mt-4 pt-4 border-t space-y-4">
//                     <label className="block text-sm font-bold text-gray-700">Tiêu đề tab (VI)</label>
//                     <input type="text" name="tabs.product_info.title_vi" value={selectedProduct.tabs.product_info.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded" />
//                     <label className="block text-sm font-bold text-gray-700">Công dụng (VI) (mỗi mục một dòng)</label>
//                     <textarea name="tabs.product_info.content.benefits_vi" value={selectedProduct.tabs.product_info.content.benefits_vi.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
//                     <label className="block text-sm font-bold text-gray-700">Đặc điểm nổi bật CHI TIẾT (VI) (mỗi mục một dòng)</label>
//                     <textarea name="tabs.product_info.content.features_vi" value={selectedProduct.tabs.product_info.content.features_vi.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
//                     <hr className="my-2"/>
//                     <label className="block text-sm font-bold text-gray-700">Tab Title (EN)</label>
//                     <input type="text" name="tabs.product_info.title_en" value={selectedProduct.tabs.product_info.title_en} onChange={handleInputChange} className="w-full p-2 border rounded" />
//                     <label className="block text-sm font-bold text-gray-700">Benefits (EN) (one per line)</label>
//                     <textarea name="tabs.product_info.content.benefits_en" value={selectedProduct.tabs.product_info.content.benefits_en.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
//                     <label className="block text-sm font-bold text-gray-700">Detailed Key Features (EN) (one per line)</label>
//                     <textarea name="tabs.product_info.content.features_en" value={selectedProduct.tabs.product_info.content.features_en.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
//                     <hr className="my-2"/>
//                     <label className="block text-sm font-bold text-gray-700 mt-4">Ảnh trong tab</label>
//                     <input type="file" onChange={(e) => handleGenericImageUpload(e, 'tabs.product_info.content.image')} accept="image/png, image/jpeg, image/webp, image/gif" className="w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100 mb-2"/>
//                     {selectedProduct.tabs.product_info.content.image && (<div className="mt-2 border p-2 rounded-md w-32 h-32"><img src={createAbsoluteUrl(selectedProduct.tabs.product_info.content.image)} alt="Xem trước ảnh tab" className="w-full h-full object-contain"/></div>)}
//                   </div></details>
//                   <details className="mb-4 border rounded p-3 bg-white">
//                     <summary className="font-bold text-lg cursor-pointer text-gray-700">2. Tab: Hướng dẫn sử dụng</summary>
//                     <div className="mt-4 space-y-4">
//                       <label className="block text-sm font-bold">Tiêu đề (VI)</label>
//                       <input type="text" name="tabs.usage_guide.title_vi" value={selectedProduct.tabs.usage_guide.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">Tiêu đề (EN)</label>
//                       <input type="text" name="tabs.usage_guide.title_en" value={selectedProduct.tabs.usage_guide.title_en} onChange={handleInputChange} className="w-full p-2 border rounded"/>
//                       <h4 className="font-semibold">Phương pháp 1 (VI)</h4>
//                       <input type="text" name="tabs.usage_guide.content.method1_vi.title" value={selectedProduct.tabs.usage_guide.content.method1_vi.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
//                       <textarea name="tabs.usage_guide.content.method1_vi.steps" value={selectedProduct.tabs.usage_guide.content.method1_vi.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <h4 className="font-semibold">Method 1 (EN)</h4>
//                       <input type="text" name="tabs.usage_guide.content.method1_en.title" value={selectedProduct.tabs.usage_guide.content.method1_en.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
//                       <textarea name="tabs.usage_guide.content.method1_en.steps" value={selectedProduct.tabs.usage_guide.content.method1_en.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <h4 className="font-semibold">Phương pháp 2 (VI)</h4>
//                       <input type="text" name="tabs.usage_guide.content.method2_vi.title" value={selectedProduct.tabs.usage_guide.content.method2_vi.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
//                       <textarea name="tabs.usage_guide.content.method2_vi.steps" value={selectedProduct.tabs.usage_guide.content.method2_vi.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <h4 className="font-semibold">Method 2 (EN)</h4>
//                       <input type="text" name="tabs.usage_guide.content.method2_en.title" value={selectedProduct.tabs.usage_guide.content.method2_en.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
//                       <textarea name="tabs.usage_guide.content.method2_en.steps" value={selectedProduct.tabs.usage_guide.content.method2_en.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">Video URL</label>
//                       <input type="text" name="tabs.usage_guide.content.video" value={selectedProduct.tabs.usage_guide.content.video} onChange={handleInputChange} className="w-full p-2 border rounded"/>
//                     </div>
//                   </details>
//                   <details className="border rounded p-3 bg-white">
//                     <summary className="font-bold text-lg cursor-pointer text-gray-700">3. Tab: Thông số kỹ thuật</summary>
//                     <div className="mt-4 space-y-4">
//                       <label className="block text-sm font-bold">Tiêu đề (VI)</label>
//                       <input type="text" name="tabs.tech_specs.title_vi" value={selectedProduct.tabs.tech_specs.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">Thông số (VI) (mỗi dòng một thông số)</label>
//                       <textarea name="tabs.tech_specs.content.specs_vi" value={selectedProduct.tabs.tech_specs.content.specs_vi.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">Tab Title (EN)</label>
//                       <input type="text" name="tabs.tech_specs.title_en" value={selectedProduct.tabs.tech_specs.title_en} onChange={handleInputChange} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">Specifications (EN) (one per line)</label>
//                       <textarea name="tabs.tech_specs.content.specs_en" value={selectedProduct.tabs.tech_specs.content.specs_en.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
//                       <label className="block text-sm font-bold">File PDF</label>
//                       <input type="file" onChange={handlePdfUpload} className="w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-pink-50 file:text-pink-700 hover:file:bg-pink-100"/>
//                       {isPdfUploading && <p>Đang tải PDF...</p>}
//                       {selectedProduct.tabs.tech_specs.content.pdf && (
//                         <button
//                           type="button"
//                           onClick={async () => {
//                             if (!window.confirm("Xoá file PDF này?")) return;
//                             try {
//                               const token = getAuthToken();
//                               if (!token) throw new Error("Vui lòng đăng nhập lại.");

//                               // ✅ Gọi API xoá Cloudinary
//                               await api.delete("/upload/delete", {
//                                 headers: { Authorization: `Bearer ${token}` },
//                                 data: {
//                                   public_id: selectedProduct.tabs.tech_specs.content.pdfId, // ✅ lấy public_id đã lưu
//                                   resource_type: "raw",
//                                 },
//                               });

//                               // ✅ Sau khi xoá thành công, cập nhật lại state: xoá pdf + pdfId
//                               setSelectedProduct((prev) =>
//                                 prev
//                                   ? {
//                                       ...prev,
//                                       tabs: {
//                                         ...prev.tabs,
//                                         tech_specs: {
//                                           ...prev.tabs.tech_specs,
//                                           content: {
//                                             ...prev.tabs.tech_specs.content,
//                                             pdf: "",
//                                             pdfId: "",
//                                           },
//                                         },
//                                       },
//                                     }
//                                   : null
//                               );

//                               alert("Đã xoá PDF thành công!");
//                             } catch (err) {
//                               console.error("❌ Lỗi khi xoá PDF:", err);
//                               alert("Không thể xoá PDF.");
//                             }
//                           }}
//                           className="ml-3 text-red-600 text-sm underline"
//                         >
//                           Xoá PDF
//                         </button>
//                       )}


//                       </div>
//                   </details>
//                 </div>
//                 <div className="p-4 border rounded-md bg-gray-50">
//                   <h3 className="font-bold text-lg mb-3">FAQ</h3>
//                   <h4 className="font-semibold text-blue-600 mb-2">Câu hỏi thường gặp (VI)</h4>
//                   {selectedProduct.faq_vi.map((item, index) => (<div key={index} className="mb-4 p-2 border rounded"><input type="text" placeholder="Câu hỏi" value={item.question} onChange={(e) => handleFaqChange(index, 'vi', 'question', e.target.value)} className="w-full p-2 border rounded mb-2"/><textarea placeholder="Trả lời" value={item.answer} onChange={(e) => handleFaqChange(index, 'vi', 'answer', e.target.value)} rows={2} className="w-full p-2 border rounded mb-2"/><button type="button" onClick={() => removeFaqItem(index, 'vi')} className="bg-red-500 text-white px-3 py-1 rounded">Xóa</button></div>))}
//                   <button type="button" onClick={() => addFaqItem('vi')} className="bg-green-600 text-white px-3 py-1 rounded">+ Thêm câu hỏi VI</button>
//                   <hr className="my-4"/>
//                   <h4 className="font-semibold text-green-600 mb-2">Frequently Asked Questions (EN)</h4>
//                   {selectedProduct.faq_en.map((item, index) => (<div key={index} className="mb-4 p-2 border rounded"><input type="text" placeholder="Question" value={item.question} onChange={(e) => handleFaqChange(index, 'en', 'question', e.target.value)} className="w-full p-2 border rounded mb-2"/><textarea placeholder="Answer" value={item.answer} onChange={(e) => handleFaqChange(index, 'en', 'answer', e.target.value)} rows={2} className="w-full p-2 border rounded mb-2"/><button type="button" onClick={() => removeFaqItem(index, 'en')} className="bg-red-500 text-white px-3 py-1 rounded">Delete</button></div>))}
//                   <button type="button" onClick={() => addFaqItem('en')} className="bg-green-600 text-white px-3 py-1 rounded">+ Add Question EN</button>
//                 </div>
//                 <div className="flex flex-col sm:flex-row gap-4 mt-6">
//                   <button type="submit" disabled={isSaving} className="bg-blue-600 text-white px-6 py-2 rounded font-bold hover:bg-blue-700 disabled:bg-gray-400">{isSaving ? 'Đang lưu...' : (isCreating ? 'Tạo sản phẩm' : 'Lưu thay đổi')}</button>
//                   {!isCreating && (<button type="button" onClick={handleDelete} className="bg-red-600 text-white px-6 py-2 rounded font-bold hover:bg-red-700">Xóa sản phẩm</button>)}
//                 </div>
//               </div>
//             </form>
//           ) : (<div className="flex items-center justify-center h-full text-gray-500 min-h-[500px]"><p className="text-xl">Vui lòng chọn sản phẩm để chỉnh sửa hoặc tạo sản phẩm mới.</p></div>)}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QLSanPham;

import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { DragDropContext, Droppable, Draggable, DropResult, DroppableProvided, DraggableProvided } from '@hello-pangea/dnd';
import imageCompression from "browser-image-compression";

import api from '../../api/axiosConfig';

// =============================================================================
// INTERFACE
// =============================================================================
interface ProductData {
  _id?: string;
  slug: string;
  isVisible: boolean;
  order: number;
  name_vi: string;
  name_en: string;
  description_vi: string;
  description_en: string;
  short_features_vi: string[];
  short_features_en: string[];
  relatedProducts: string[];
  
  // MAIN IMAGE
  mainImage: string;
  mainImageId?: string;          
  oldMainImageId?: string;       

  // GALLERY
  galleryImages: string[];
  galleryImageIds?: string[];    

  volumes: string[];
  tabs: {
    product_info: {
      title_vi: string;
      title_en: string;
      content: {
        benefits_vi: string[];
        benefits_en: string[];
        features_vi: string[];
        features_en: string[];
        image: string;
        imageId?: string;
      };
    };
    usage_guide: {
      title_vi: string;
      title_en: string;
      content: {
        method1_vi: { title: string; steps: string[] };
        method1_en: { title: string; steps: string[] };
        method2_vi: { title: string; steps: string[] };
        method2_en: { title: string; steps: string[] };
        video: string;
      };
    };
    tech_specs: {
      title_vi: string;
      title_en: string;
      content: {
        specs_vi: string[];
        specs_en: string[];
        pdf: string;
        pdfId?: string;      
      };
    };
  };
  faq_vi: Array<{ question: string; answer: string }>;
  faq_en: Array<{ question: string; answer: string }>;
  
  oldPdfId?: string;         
}

const getAuthToken = (): string | null => {
  const userString = sessionStorage.getItem('user');
  if (userString) {
    try {
      const userData = JSON.parse(userString);
      return userData.accessToken || null;
    } catch (error) {
      return null;
    }
  }
  return null;
};

const createAbsoluteUrl = (path: string | undefined | null) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = (api.defaults.baseURL || '').replace(/\/api\/?$/, '');
  return `${base}${path}`;
};

// =============================================================================
// BLANK PRODUCT
// =============================================================================
const blankProduct: ProductData = {
  slug: '',
  isVisible: false,
  order: 0,
  name_vi: '',
  name_en: '',
  description_vi: '',
  description_en: '',
  short_features_vi: [],
  short_features_en: [],
  relatedProducts: [],
  mainImage: '',
  mainImageId: '',
  galleryImages: [],
  galleryImageIds: [], 
  volumes: [],
  tabs: {
    product_info: {
      title_vi: 'Thông tin sản phẩm',
      title_en: 'Product Information',
      content: { benefits_vi: [], benefits_en: [], features_vi: [], features_en: [], image: '', imageId: '' },
    },
    usage_guide: {
      title_vi: 'Hướng dẫn sử dụng',
      title_en: 'Usage Guide',
      content: {
        method1_vi: { title: 'Cách sử dụng 1:', steps: [] },
        method1_en: { title: 'Method 1:', steps: [] },
        method2_vi: { title: 'Cách sử dụng 2:', steps: [] },
        method2_en: { title: 'Method 2:', steps: [] },
        video: '',
      },
    },
    tech_specs: {
      title_vi: 'Thông số kỹ thuật',
      title_en: 'Technical Specs',
      content: { specs_vi: [], specs_en: [], pdf: '', pdfId: '' },
    },
  },
  faq_vi: [],
  faq_en: [],
};

const QLSanPham = () => {
  const [products, setProducts] = useState<{ slug: string; name_vi: string; isVisible: boolean; order: number }[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<ProductData | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  
  // Upload states
  const [isUploading, setIsUploading] = useState(false);
  const [isGalleryUploading, setIsGalleryUploading] = useState(false);
  const [isPdfUploading, setIsPdfUploading] = useState(false);
  const [isTogglingVisibility, setIsTogglingVisibility] = useState(false);

  // --- FETCH PRODUCTS ---
  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const token = getAuthToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await api.get('/products?admin=true', config);
      setProducts(
        data.map((p: any) => ({
          slug: p.slug,
          name_vi: p.name_vi,
          isVisible: p.isVisible,
          order: p.order ?? 0,
        }))
        .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
      );
    } catch (error) {
      console.error('Lỗi khi tải danh sách:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- REORDER ---
  const handleReorder = async (result: DropResult) => {
    if (!result.destination) return;
    const newItems = Array.from(products);
    const [moved] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, moved);

    const reorderedWithOrder = newItems.map((p, index) => ({
      ...p,
      order: index,
    }));
    setProducts(reorderedWithOrder);

    try {
      const token = getAuthToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await api.post("/products/reorder", reorderedWithOrder, config);
    } catch (error) {
      console.error("Lỗi reorder:", error);
      alert("Không thể lưu thứ tự mới!");
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleNewProduct = () => {
    setSelectedProduct(blankProduct);
    setIsCreating(true);
  };

  const handleSelectProduct = async (slug: string) => {
    setIsLoading(true);
    setIsCreating(false);
    setSelectedProduct(null);
    try {
      const token = getAuthToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await api.get(`/products/${slug}`, config);
      setSelectedProduct(data);
    } catch (error) {
      console.error(`Lỗi tải chi tiết ${slug}:`, error);
      alert('Không thể tải chi tiết sản phẩm.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!selectedProduct) return;
    const { name, value } = e.target;

    setSelectedProduct(prev => {
      if (!prev) return null;
      const newState = JSON.parse(JSON.stringify(prev));
      const keys = name.split('.');
      let currentLevel = newState;
      for (let i = 0; i < keys.length - 1; i++) {
        if (currentLevel[keys[i]] === undefined) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }
      const finalKey = keys[keys.length - 1];
      const arrayFields = ['galleryImages', 'short_features_vi', 'short_features_en', 'relatedProducts', 'volumes', 'benefits_vi', 'benefits_en', 'features_vi', 'features_en', 'specs_vi', 'specs_en', 'steps'];
      if (arrayFields.includes(finalKey)) {
        currentLevel[finalKey] = value.split('\n').filter(line => line.trim() !== '');
      } else {
        currentLevel[finalKey] = value;
      }
      return newState;
    });
  };
  
  const handleToggleVisibility = async () => { 
    if (!selectedProduct || isSaving || isTogglingVisibility) return; 
    setIsTogglingVisibility(true); 
    const newVisibility = !selectedProduct.isVisible; 
    try { 
      const token = getAuthToken(); 
      if (!token) throw new Error("Vui lòng đăng nhập lại."); 
      const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
      await api.patch(`/products/${selectedProduct.slug}/visibility`, { isVisible: newVisibility }, apiConfig); 
      setSelectedProduct({ ...selectedProduct, isVisible: newVisibility }); 
      fetchProducts(); 
    } catch (error: any) { 
      alert(error.response?.data?.message || "Cập nhật trạng thái thất bại!"); 
    } finally { 
      setIsTogglingVisibility(false); 
    } 
  };
  
  // =============================================================================
  // 1. UPLOAD SINGLE IMAGE (MAIN + TAB IMAGE)
  // =============================================================================
  const handleGenericImageUpload = async (e: ChangeEvent<HTMLInputElement>, fieldName: string) => {
    let file = e.target.files?.[0];
    if (!file) return;

    try {
      const options = { maxSizeMB: 1, maxWidthOrHeight: 1600, useWebWorker: true, fileType: "image/webp" };
      file = await imageCompression(file, options);
    } catch (err) {
      console.warn("Lỗi nén ảnh:", err);
    }

    const formData = new FormData();
    formData.append("file", file);
    setIsUploading(true);

    try {
      const token = getAuthToken();
      const config = { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` } };
      const { data } = await api.post("/upload/image?scope=products", formData, config);
      const { url, public_id } = data;

      if (fieldName === "mainImage") {
        setSelectedProduct((prev) => {
          if (!prev) return null;
          return {
            ...prev,
            mainImage: url,
            mainImageId: public_id,
            oldMainImageId: prev.oldMainImageId ? prev.oldMainImageId : prev.mainImageId
          };
        });
      } else {
        const syntheticEvent = { target: { name: fieldName, value: url, type: "text" } } as any;
        handleInputChange(syntheticEvent);
      }
    } catch (error) {
      console.error(`Lỗi upload ${fieldName}:`, error);
      alert("Tải ảnh thất bại.");
    } finally {
      setIsUploading(false);
    }
  };
  
  // =============================================================================
  // 2. UPLOAD GALLERY (MULTIPLE)
  // =============================================================================
  const handleGalleryUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const token = getAuthToken();
    if (!token) return alert("Bạn chưa đăng nhập");

    setIsGalleryUploading(true);
    const config = { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` } };

    const newUrls: string[] = [];
    const newIds: string[] = [];

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      try {
        const options = { maxSizeMB: 1, maxWidthOrHeight: 1600, useWebWorker: true, fileType: "image/webp" };
        file = await imageCompression(file, options);
      } catch (err) {}

      const formData = new FormData();
      formData.append("files", file);

      try {
        const { data } = await api.post("/upload/images?scope=products", formData, config);
        if(data.items && data.items.length > 0) {
            newUrls.push(data.items[0].url);
            newIds.push(data.items[0].public_id);
        }
      } catch (error) {
        console.error("Lỗi 1 ảnh gallery:", error);
      }
    }

    setSelectedProduct((prev) =>
      prev
        ? {
            ...prev,
            galleryImages: [...prev.galleryImages, ...newUrls],
            galleryImageIds: [...(prev.galleryImageIds || []), ...newIds],
          }
        : null
    );

    setIsGalleryUploading(false);
  };
  
  // =============================================================================
  // 3. REMOVE GALLERY IMAGE
  // =============================================================================
  const handleRemoveGalleryImage = async (index: number) => { 
    if (!selectedProduct) return;
    
    const idToRemove = selectedProduct.galleryImageIds?.[index];

    if(!window.confirm("Bạn muốn xoá ảnh này khỏi thư viện?")) return;

    if (idToRemove) {
        try {
            const token = getAuthToken();
            if(token) {
                 await api.delete("/upload/delete", {
                    headers: { Authorization: `Bearer ${token}` },
                    data: { public_id: idToRemove, resource_type: "image" },
                });
            }
        } catch (e) {
            console.error("Lỗi xoá ảnh trên Cloudinary:", e);
        }
    }

    const newGallery = [...selectedProduct.galleryImages];
    const newGalleryIds = [...(selectedProduct.galleryImageIds || [])];

    newGallery.splice(index, 1);
    newGalleryIds.splice(index, 1);

    setSelectedProduct({ 
        ...selectedProduct, 
        galleryImages: newGallery,
        galleryImageIds: newGalleryIds
    }); 
  };
  
  // =============================================================================
  // 4. UPLOAD PDF
  // =============================================================================
  const handlePdfUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.type !== "application/pdf") return alert("Chọn đúng file PDF!");
    if (file.size / 1024 / 1024 > 5) return alert("File PDF > 5MB!");

    const formData = new FormData();
    formData.append("file", file);
    setIsPdfUploading(true);

    try {
      const token = getAuthToken();
      const config = { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` } };
      const { data } = await api.post("/upload/pdf?scope=docs", formData, config);
      const { url, public_id } = data;

      setSelectedProduct((prev) => {
         if (!prev) return null;
         const currentPdfId = prev.tabs.tech_specs.content.pdfId;
         return {
            ...prev,
            tabs: {
              ...prev.tabs,
              tech_specs: {
                ...prev.tabs.tech_specs,
                content: {
                  ...prev.tabs.tech_specs.content,
                  pdf: url,
                  pdfId: public_id,
                },
              },
            },
            oldPdfId: prev.oldPdfId ? prev.oldPdfId : currentPdfId
          };
      });
      alert("Tải file PDF thành công!");
    } catch (error: any) {
      alert("Tải PDF thất bại.");
    } finally {
      setIsPdfUploading(false);
    }
  };

  // =============================================================================
  // SAVE & DELETE
  // =============================================================================
  const handleSave = async () => { 
    if (!selectedProduct) return; 
    
    if (isCreating) { 
      const requiredFields = { slug: 'Slug', name_vi: 'Tên (VI)', name_en: 'Name (EN)', mainImage: 'Ảnh đại diện' }; 
      for (const [key, name] of Object.entries(requiredFields)) { 
        if (!selectedProduct[key as keyof ProductData]) { 
          alert(`Thiếu: "${name}"`); 
          return; 
        } 
      } 
    } 

    setIsSaving(true); 
    try { 
      const token = getAuthToken(); 
      if (!token) throw new Error("Vui lòng đăng nhập lại."); 
      const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
      
      const payload = { ...selectedProduct };

      if (isCreating) { 
        await api.post('/products', payload, apiConfig); 
        alert(`Tạo thành công!`); 
      } else { 
        await api.put(`/products/${selectedProduct.slug}`, payload, apiConfig);
        alert(`Lưu thành công!`); 
      } 
      
      setSelectedProduct(null); 
      fetchProducts(); 
    } catch (error: any) { 
      console.error("Lỗi save:", error); 
      alert(error.response?.data?.message || "Lỗi lưu dữ liệu!"); 
    } finally { 
      setIsSaving(false); 
    } 
  };

  const handleDelete = async () => { 
    if (!selectedProduct) return; 
    if (window.confirm(`Xóa sản phẩm "${selectedProduct.name_vi}"?`)) { 
      try { 
        const token = getAuthToken(); 
        const apiConfig = { headers: { Authorization: `Bearer ${token}` } }; 
        await api.delete(`/products/${selectedProduct.slug}`, apiConfig); 
        alert('Đã xóa!'); 
        setSelectedProduct(null); 
        fetchProducts(); 
      } catch (error: any) { 
        alert("Lỗi xóa!"); 
      } 
    } 
  };
  
  // Helpers FAQ
  const handleFaqChange = (index: number, lang: 'vi' | 'en', field: 'question' | 'answer', value: string) => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const updatedFaqs = [...selectedProduct[faqKey]]; updatedFaqs[index] = { ...updatedFaqs[index], [field]: value }; setSelectedProduct({ ...selectedProduct, [faqKey]: updatedFaqs }); };
  const addFaqItem = (lang: 'vi' | 'en') => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const newFaq = { question: '', answer: '' }; setSelectedProduct({ ...selectedProduct, [faqKey]: [...selectedProduct[faqKey], newFaq] }); };
  const removeFaqItem = (index: number, lang: 'vi' | 'en') => { if (!selectedProduct) return; const faqKey = `faq_${lang}` as 'faq_vi' | 'faq_en'; const updatedFaqs = selectedProduct[faqKey].filter((_, i: number) => i !== index); setSelectedProduct({ ...selectedProduct, [faqKey]: updatedFaqs }); };
  const handleFormSubmit = (e: FormEvent) => { e.preventDefault(); handleSave(); };

  // =============================================================================
  // RENDER
  // =============================================================================
  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 lg:p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Quản Lý Sản Phẩm</h1>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {/* LIST PANEL */}
        <div className="md:col-span-4 lg:col-span-3 bg-white p-4 rounded-lg shadow-md self-start">
          <button onClick={handleNewProduct} className="w-full bg-green-600 text-white font-bold py-2 px-4 rounded mb-4">+ Tạo Mới</button>
          {isLoading ? <p>Đang tải...</p> : (
            <DragDropContext onDragEnd={handleReorder}>
              <Droppable droppableId="productList">
                {(provided: DroppableProvided) => (
                  <ul ref={provided.innerRef} {...provided.droppableProps} className="space-y-2 select-none">
                    {products.map((product, index) => (
                      <Draggable key={product.slug} draggableId={product.slug} index={index}>
                        {(provided: DraggableProvided) => (
                          <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} 
                              className={`border rounded p-3 bg-gray-50 cursor-grab flex justify-between ${selectedProduct?.slug === product.slug ? 'ring-2 ring-blue-400' : ''}`}>
                             <div onClick={() => handleSelectProduct(product.slug)} className="flex-1 cursor-pointer font-medium">
                               {index + 1}. {product.name_vi}
                             </div>
                             <span className={`text-xs px-2 py-1 rounded-full h-fit ${product.isVisible ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                               {product.isVisible ? 'Bật' : 'Tắt'}
                             </span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>

        {/* EDITOR PANEL */}
        <div className="md:col-span-8 lg:col-span-9 bg-white p-6 rounded-lg shadow-md">
          {!selectedProduct ? (
            <div className="flex justify-center items-center h-full text-gray-500 min-h-[500px]"><p>Chọn sản phẩm để chỉnh sửa</p></div>
          ) : (
            <form onSubmit={handleFormSubmit}>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">{isCreating ? "Tạo Mới" : selectedProduct.name_vi}</h2>
                <div className="flex gap-2">
                    <span className={`px-3 py-1 font-bold rounded ${selectedProduct.isVisible ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {selectedProduct.isVisible ? 'Hiển thị' : 'Đang ẩn'}
                    </span>
                    <button type="button" onClick={handleToggleVisibility} disabled={isTogglingVisibility} className="text-sm underline text-blue-600">
                        {isTogglingVisibility ? '...' : 'Đổi trạng thái'}
                    </button>
                </div>
              </div>

              <div className="space-y-6">
                {/* 1. INFO CHUNG */}
                <div className="p-4 border rounded bg-gray-50">
                  <h3 className="font-bold text-lg mb-3">Thông Tin Chung</h3>
                  <label className="block text-sm font-bold mb-1">Slug</label>
                  <input type="text" name="slug" value={selectedProduct.slug} onChange={handleInputChange} className={`w-full p-2 border rounded mb-4 ${!isCreating ? 'bg-gray-200' : ''}`} readOnly={!isCreating} />
                  
                  {/* MAIN IMAGE */}
                  <label className="block text-sm font-bold mb-1">Ảnh đại diện</label>
                  <input type="file" onChange={(e) => handleGenericImageUpload(e, 'mainImage')} className="mb-2"/>
                  {isUploading && <p className="text-sm text-blue">Đang upload...</p>}
                  {selectedProduct.mainImage && <img src={createAbsoluteUrl(selectedProduct.mainImage)} className="h-32 border p-1 rounded object-contain"/>}

                  {/* GALLERY */}
                  <label className="block text-sm font-bold mt-4 mb-1">Thư viện ảnh</label>
                  <input type="file" multiple onChange={handleGalleryUpload} className="mb-2"/>
                  {isGalleryUploading && <p className="text-sm text-green">Đang upload gallery...</p>}
                  <div className="flex flex-wrap gap-4 mt-2">
                    {selectedProduct.galleryImages.map((url, index) => (
                      <div key={index} className="relative w-32 h-32 border p-1 rounded">
                        <img src={createAbsoluteUrl(url)} className="w-full h-full object-contain" />
                        <button type="button" onClick={() => handleRemoveGalleryImage(index)} className="absolute top-0 right-0 bg-red-500 text-white w-6 h-6 rounded-full -mt-2 -mr-2">×</button>
                      </div>
                    ))}
                  </div>
                  
                  <label className="block text-sm font-bold mt-4 mb-1">Sản phẩm liên quan (slugs)</label>
                  <textarea name="relatedProducts" value={selectedProduct.relatedProducts.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
                   
                  <label className="block text-sm font-bold mt-4 mb-1">Dung tích (mỗi dòng 1 loại)</label>
                  <textarea name="volumes" value={selectedProduct.volumes.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded" placeholder="500ml..."/>
                </div>

                {/* 2. NỘI DUNG VI/EN */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-4 border rounded bg-blue-50">
                        <h3 className="font-bold text-blue-800 mb-2">Tiếng Việt</h3>
                        <input name="name_vi" value={selectedProduct.name_vi} onChange={handleInputChange} placeholder="Tên SP" className="w-full p-2 border rounded mb-2"/>
                        <textarea name="description_vi" value={selectedProduct.description_vi} onChange={handleInputChange} rows={3} placeholder="Mô tả" className="w-full p-2 border rounded mb-2"/>
                        <textarea name="short_features_vi" value={selectedProduct.short_features_vi.join('\n')} onChange={handleInputChange} rows={3} placeholder="Đặc điểm (từng dòng)" className="w-full p-2 border rounded"/>
                    </div>
                    <div className="p-4 border rounded bg-green-50">
                        <h3 className="font-bold text-green-800 mb-2">English</h3>
                        <input name="name_en" value={selectedProduct.name_en} onChange={handleInputChange} placeholder="Product Name" className="w-full p-2 border rounded mb-2"/>
                        <textarea name="description_en" value={selectedProduct.description_en} onChange={handleInputChange} rows={3} placeholder="Description" className="w-full p-2 border rounded mb-2"/>
                        <textarea name="short_features_en" value={selectedProduct.short_features_en.join('\n')} onChange={handleInputChange} rows={3} placeholder="Features (one per line)" className="w-full p-2 border rounded"/>
                    </div>
                </div>

                {/* 3. TABS CHI TIẾT */}
                <div className="p-4 border rounded bg-gray-50">
                    <h3 className="font-bold mb-4 text-xl text-center">Chi Tiết Sản Phẩm (Tabs)</h3>
                    
                    {/* --- Tab 1: Product Info --- */}
                    <details className="mb-4 bg-white p-3 rounded border shadow-sm" open>
                        <summary className="font-bold cursor-pointer text-blue-700">1. Tab: Thông tin sản phẩm</summary>
                        <div className="mt-4 space-y-4">
                             {/* VI */}
                             <div className="border-l-4 border-blue-500 pl-3">
                                <label className="block text-sm font-bold text-blue-700">Tiêu đề (VI)</label>
                                <input type="text" name="tabs.product_info.title_vi" value={selectedProduct.tabs.product_info.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded mb-2" />
                                <label className="block text-sm font-bold text-blue-700">Công dụng (VI) (mỗi mục một dòng)</label>
                                <textarea name="tabs.product_info.content.benefits_vi" value={selectedProduct.tabs.product_info.content.benefits_vi.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded mb-2" />
                                <label className="block text-sm font-bold text-blue-700">Đặc điểm chi tiết (VI)</label>
                                <textarea name="tabs.product_info.content.features_vi" value={selectedProduct.tabs.product_info.content.features_vi.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
                             </div>
                             
                             <hr/>

                             {/* EN */}
                             <div className="border-l-4 border-green-500 pl-3">
                                <label className="block text-sm font-bold text-green-700">Tab Title (EN)</label>
                                <input type="text" name="tabs.product_info.title_en" value={selectedProduct.tabs.product_info.title_en} onChange={handleInputChange} className="w-full p-2 border rounded mb-2" />
                                <label className="block text-sm font-bold text-green-700">Benefits (EN) (one per line)</label>
                                <textarea name="tabs.product_info.content.benefits_en" value={selectedProduct.tabs.product_info.content.benefits_en.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded mb-2" />
                                <label className="block text-sm font-bold text-green-700">Detailed Features (EN)</label>
                                <textarea name="tabs.product_info.content.features_en" value={selectedProduct.tabs.product_info.content.features_en.join('\n')} onChange={handleInputChange} rows={4} className="w-full p-2 border rounded" />
                             </div>

                             <div className="mt-4">
                                <label className="block text-sm font-bold">Ảnh minh hoạ Tab</label>
                                <input type="file" onChange={(e) => handleGenericImageUpload(e, 'tabs.product_info.content.image')} className="mb-2"/>
                                {selectedProduct.tabs.product_info.content.image && <img src={createAbsoluteUrl(selectedProduct.tabs.product_info.content.image)} className="h-32 border p-1 rounded object-contain"/>}
                             </div>
                        </div>
                    </details>
                    
                    {/* --- Tab 2: Usage Guide --- */}
                    <details className="mb-4 bg-white p-3 rounded border shadow-sm">
                        <summary className="font-bold cursor-pointer text-blue-700">2. Tab: Hướng dẫn sử dụng</summary>
                        <div className="mt-4 space-y-4">
                            {/* General */}
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-bold text-blue-700">Tiêu đề (VI)</label>
                                    <input name="tabs.usage_guide.title_vi" value={selectedProduct.tabs.usage_guide.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded"/>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-green-700">Title (EN)</label>
                                    <input name="tabs.usage_guide.title_en" value={selectedProduct.tabs.usage_guide.title_en} onChange={handleInputChange} className="w-full p-2 border rounded"/>
                                </div>
                            </div>
                            
                            {/* Method 1 */}
                            <div className="border p-3 rounded bg-gray-50">
                                <h4 className="font-bold mb-2">Phương pháp 1 / Method 1</h4>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <input placeholder="Tên cách 1 (VI)" name="tabs.usage_guide.content.method1_vi.title" value={selectedProduct.tabs.usage_guide.content.method1_vi.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                        <textarea placeholder="Các bước (VI)" name="tabs.usage_guide.content.method1_vi.steps" value={selectedProduct.tabs.usage_guide.content.method1_vi.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
                                    </div>
                                    <div>
                                        <input placeholder="Method 1 Title (EN)" name="tabs.usage_guide.content.method1_en.title" value={selectedProduct.tabs.usage_guide.content.method1_en.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                        <textarea placeholder="Steps (EN)" name="tabs.usage_guide.content.method1_en.steps" value={selectedProduct.tabs.usage_guide.content.method1_en.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
                                    </div>
                                </div>
                            </div>

                            {/* Method 2 */}
                            <div className="border p-3 rounded bg-gray-50">
                                <h4 className="font-bold mb-2">Phương pháp 2 / Method 2</h4>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <input placeholder="Tên cách 2 (VI)" name="tabs.usage_guide.content.method2_vi.title" value={selectedProduct.tabs.usage_guide.content.method2_vi.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                        <textarea placeholder="Các bước (VI)" name="tabs.usage_guide.content.method2_vi.steps" value={selectedProduct.tabs.usage_guide.content.method2_vi.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
                                    </div>
                                    <div>
                                        <input placeholder="Method 2 Title (EN)" name="tabs.usage_guide.content.method2_en.title" value={selectedProduct.tabs.usage_guide.content.method2_en.title} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                        <textarea placeholder="Steps (EN)" name="tabs.usage_guide.content.method2_en.steps" value={selectedProduct.tabs.usage_guide.content.method2_en.steps.join('\n')} onChange={handleInputChange} rows={3} className="w-full p-2 border rounded"/>
                                    </div>
                                </div>
                            </div>

                            <label className="block text-sm font-bold">Video URL</label>
                            <input name="tabs.usage_guide.content.video" value={selectedProduct.tabs.usage_guide.content.video} onChange={handleInputChange} className="w-full p-2 border rounded"/>
                        </div>
                    </details>

                    {/* --- Tab 3: Tech Specs --- */}
                    <details className="mb-4 bg-white p-3 rounded border shadow-sm">
                        <summary className="font-bold cursor-pointer text-blue-700">3. Tab: Thông số & PDF</summary>
                        <div className="mt-4 space-y-4">
                             <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-bold text-blue-700">Tiêu đề (VI)</label>
                                    <input name="tabs.tech_specs.title_vi" value={selectedProduct.tabs.tech_specs.title_vi} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                    <label className="block text-sm font-bold text-blue-700">Thông số (VI)</label>
                                    <textarea name="tabs.tech_specs.content.specs_vi" value={selectedProduct.tabs.tech_specs.content.specs_vi.join('\n')} onChange={handleInputChange} rows={5} className="w-full p-2 border rounded"/>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-green-700">Title (EN)</label>
                                    <input name="tabs.tech_specs.title_en" value={selectedProduct.tabs.tech_specs.title_en} onChange={handleInputChange} className="w-full p-2 border rounded mb-2"/>
                                    <label className="block text-sm font-bold text-green-700">Specs (EN)</label>
                                    <textarea name="tabs.tech_specs.content.specs_en" value={selectedProduct.tabs.tech_specs.content.specs_en.join('\n')} onChange={handleInputChange} rows={5} className="w-full p-2 border rounded"/>
                                </div>
                             </div>

                             <div className="mt-4 border-t pt-2">
                                <label className="block text-sm font-bold">File PDF Tech Specs</label>
                                <input type="file" onChange={handlePdfUpload} accept="application/pdf" className="mt-1"/>
                                {isPdfUploading && <span className="text-blue-500 text-sm ml-2">Uploading PDF...</span>}
                                {selectedProduct.tabs.tech_specs.content.pdf && (
                                    <div className="flex items-center gap-4 mt-2 bg-gray-50 p-2 rounded w-fit">
                                        <a href={createAbsoluteUrl(selectedProduct.tabs.tech_specs.content.pdf)} target="_blank" rel="noreferrer" className="text-blue-600 underline text-sm font-semibold">
                                            📄 Xem PDF hiện tại
                                        </a>
                                        <button type="button" className="text-red-500 underline text-sm" 
                                            onClick={async () => {
                                                if(!window.confirm("Xoá PDF?")) return;
                                                try {
                                                    const token = getAuthToken();
                                                    if(selectedProduct.tabs.tech_specs.content.pdfId) {
                                                         await api.delete("/upload/delete", {
                                                            headers: { Authorization: `Bearer ${token}` },
                                                            data: { public_id: selectedProduct.tabs.tech_specs.content.pdfId, resource_type: "raw" },
                                                        });
                                                    }
                                                    setSelectedProduct(prev => prev ? {
                                                        ...prev,
                                                        tabs: { ...prev.tabs, tech_specs: { ...prev.tabs.tech_specs, content: { ...prev.tabs.tech_specs.content, pdf: "", pdfId: "" } } },
                                                        oldPdfId: "" 
                                                    } : null);
                                                } catch(e) { alert("Lỗi xoá PDF"); }
                                            }}>
                                            Xoá PDF
                                        </button>
                                    </div>
                                )}
                             </div>
                        </div>
                    </details>
                </div>

                {/* 4. FAQ SECTION (VI + EN) */}
                <div className="p-4 border rounded bg-gray-50">
                    <h3 className="font-bold text-lg mb-3">Câu Hỏi Thường Gặp (FAQ)</h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* FAQ VI */}
                        <div>
                            <div className="flex justify-between items-center mb-2">
                                <h4 className="font-bold text-blue-700">Tiếng Việt</h4>
                                <button type="button" onClick={() => addFaqItem('vi')} className="bg-blue-600 text-white text-xs px-2 py-1 rounded">+ Thêm câu hỏi</button>
                            </div>
                            <div className="space-y-3">
                                {selectedProduct.faq_vi.map((item, index) => (
                                    <div key={index} className="p-2 border rounded bg-white relative group">
                                        <input placeholder="Câu hỏi" value={item.question} onChange={(e) => handleFaqChange(index, 'vi', 'question', e.target.value)} className="w-full p-1 border rounded mb-1 text-sm font-semibold"/>
                                        <textarea placeholder="Trả lời" value={item.answer} onChange={(e) => handleFaqChange(index, 'vi', 'answer', e.target.value)} rows={2} className="w-full p-1 border rounded text-sm"/>
                                        <button type="button" onClick={() => removeFaqItem(index, 'vi')} className="absolute top-1 right-1 text-red-500 hover:text-red-700 font-bold px-2">×</button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* FAQ EN */}
                        <div>
                            <div className="flex justify-between items-center mb-2">
                                <h4 className="font-bold text-green-700">English</h4>
                                <button type="button" onClick={() => addFaqItem('en')} className="bg-green-600 text-white text-xs px-2 py-1 rounded">+ Add Question</button>
                            </div>
                            <div className="space-y-3">
                                {selectedProduct.faq_en.map((item, index) => (
                                    <div key={index} className="p-2 border rounded bg-white relative group">
                                        <input placeholder="Question" value={item.question} onChange={(e) => handleFaqChange(index, 'en', 'question', e.target.value)} className="w-full p-1 border rounded mb-1 text-sm font-semibold"/>
                                        <textarea placeholder="Answer" value={item.answer} onChange={(e) => handleFaqChange(index, 'en', 'answer', e.target.value)} rows={2} className="w-full p-1 border rounded text-sm"/>
                                        <button type="button" onClick={() => removeFaqItem(index, 'en')} className="absolute top-1 right-1 text-red-500 hover:text-red-700 font-bold px-2">×</button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="flex gap-4 border-t pt-4">
                  <button type="submit" disabled={isSaving} className="bg-blue-600 text-white px-6 py-2 rounded font-bold hover:bg-blue-700 disabled:bg-gray-400">
                    {isSaving ? 'Đang lưu...' : 'Lưu Sản Phẩm'}
                  </button>
                  {!isCreating && (
                    <button type="button" onClick={handleDelete} className="bg-red-600 text-white px-6 py-2 rounded font-bold hover:bg-red-700">
                        Xóa Sản Phẩm
                    </button>
                  )}
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default QLSanPham;